/* What differs between Related Entities and Business Relation. */

/* Transcribed verbatim, values included: these strings are what the API
   stores and what the card renders back through toSentenceCase. */
export const ENTITY_RELATIONS = [
  { value: "affiliate", label: "Affiliate" },
  { value: "branch", label: "Branch" },
  { value: "branch_(of_a_foreign_entity)", label: "Branch (of a Foreign Entity)" },
  { value: "corporate_office", label: "Corporate Office" },
  { value: "holding_company", label: "Holding Business" },
  { value: "parent_company", label: "Parent Business" },
  { value: "sister_company", label: "Sister Business" },
  { value: "subsidiary", label: "Subsidiary" },
];

export const BUSINESS_RELATIONS = [
  { value: "customer", label: "Customer" },
  { value: "service_provider", label: "Service Provider" },
  { value: "sub_contractor", label: "Sub Contractor" },
  { value: "supplier", label: "Supplier" },
];

export const RELATED_ENTITY_SPEC = {
  key: "entity",
  title: "Related Entities",
  addPrompt: "Add Related Entities",
  addLabel: "Add",
  dialogAdd: "Add Related Entity",
  dialogEdit: "Edit Related Entity",

  relations: ENTITY_RELATIONS,
  /* The design puts the relation first on this card and the company first on
     the other, and labels the company row differently in each. */
  rowOrder: ["relation_type", "company", "state", "country"],
  companyRowLabel: "Company",
  /* Which key the create payload carries the company's NAME under. */
  companyNameKey: "companyName",

  companyListKey: "relatedEntity",
  joinKey: "related_entityID",
  idKey: "related_entityID",
  draftIdKey: "related_entity_draftID",
  draftLinkKey: "related_entityID_id",
  /* The endpoints name their id argument this way. */
  idArg: "related_entityId",

  createRequestType: "Related Entities create draft request",
  updateRequestType: "Related Entities update draft request",
  followCreated: "New Related Entity Added",
  followUpdated: "Related Entity Updated",
  deleteMessage: "Related Entity Deleted Successfully",

  uploadPath: "authLetters",
  /* `supporting_document` and not a per-section string: the upload endpoint validates `category` against a CLOSED set (company/utils/s3_paths.py... */
  category: "supporting_document",
};

export const BUSINESS_RELATION_SPEC = {
  key: "business",
  /* The design's heading for this section really is "Add Business Relation". */
  title: "Add Business Relation",
  addPrompt: "Add Business Relation",
  addLabel: "Add Business Relation",
  dialogAdd: "Add Business Relation",
  dialogEdit: "Edit Business Relation",

  relations: BUSINESS_RELATIONS,
  rowOrder: ["company", "relation_type", "state", "country"],
  companyRowLabel: "Registered company name",
  companyNameKey: "registered_company_name",

  companyListKey: "businessRelation",
  joinKey: "business_relationID",
  idKey: "business_relationID",
  /* Capital D — transcribed, not a typo of mine. */
  draftIdKey: "business_relation_DraftID",
  draftLinkKey: "business_relationID_id",
  idArg: "business_relationId",

  /* Transcribed: this section sends NO request_type on its drafts, where
     Related Entities sends one. */
  createRequestType: null,
  updateRequestType: null,
  followCreated: "New Business Relation Added",
  followUpdated: "Business Relation Updated",
  deleteMessage: "Business Relation Deleted Successfully",

  uploadPath: "authLetters",
  /* `supporting_document` and not a per-section string: the upload endpoint validates `category` against a CLOSED set (company/utils/s3_paths.py... */
  category: "supporting_document",
};

export const RELATION_SPECS = {
  entity: RELATED_ENTITY_SPEC,
  business: BUSINESS_RELATION_SPEC,
};
